import { useTwilio } from '../contexts/TwilioContext';

/**
 * Hook simple para obtener el estado del servicio de Twilio
 */
export const useTwilioStatus = () => {
  const { 
    isDeviceReady,
    isInitializing,
    incomingCall,
    activeCall,
    isMuted
  } = useTwilio();

  return {
    isReady: isDeviceReady,
    isInitializing,
    hasIncomingCall: !!incomingCall,
    hasActiveCall: !!activeCall,
    isMuted,
    // Estado general del servicio
    status: isInitializing ? 'initializing' : isDeviceReady ? 'ready' : 'disconnected'
  };
};